import { Touch } from 'vuetify/lib/directives'
import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify, {
  directives: {
    Touch
  }
});

export default new Vuetify({});
